if(!customElements.get('configuration-section')){
  class ConfigurationSection extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback(){
        if(window.innerWidth < 1280)
          this.initializeSwiper();
    }
    initializeSwiper() {
      const el = document.querySelector(".configuration__blocks");
      if(!el) return;
      if(window.innerWidth < 749)
        el.classList.add('container');
      const wrapper = document.querySelector(".configuration__blocks .swiper-wrapper");
      wrapper?.classList.remove('flex-center');
      const scrollbarEl = document.querySelector(
        ".configuration-section .swiper-scrollbar"
      );
      this.swiper = new Swiper(el, {
        slidesPerView: "auto",
        spaceBetween: window.innerWidth < 749 ? 18 : 40,
        centerInsufficientSlides: true,
        allowTouchMove: true,
        freeMode: true,
        scrollbar: {
          el: scrollbarEl,
          draggable: true,
        },
      });
    }
  }

  customElements.define("configuration-section", ConfigurationSection);
}